<template>
<div>
    <v-server-table :name="tableName" :ref="tableName" url="/incident/list" :columns="columns" :options="options">

        <div slot="afterFilterWrapper" class="ml-md-2 ml-0 mt-md-0 mt-2 mb-md-0 mb-3 float-md-left">
            <div class="clearfix d-md-none d-block"></div>

            <div v-if="allowFilterSaving" class="float-left mr-2">
                <user-filters ref="incSavedFilters" assetType="Incident" :filterKey="filterKey" @saving="setUserFilterData" @show="setUserFilterData"></user-filters>
            </div>

            <div class="float-left">
                <table-filters-2 ref="incTableFilters"
                    filterUrl="/incident/filters"
                    v-bind:showMoreFilters="showMoreFilters"
                    v-bind:filters="filters"
                    :emptyFilters="filterDefs"
                    :filterKey="filterKey"
                    @filtersChanged="refreshTableData"
                    @filtersCleared="filtersCleared"
                    v-show="!dashboardFilters"
                    class="ml-2 mr-2">
                    <template slot-scope="slotProps">
                        <div class="d-inline-block">
                            <multi-select
                                v-model="slotProps.filters['incident.status_id']"
                                :btnLabel="(values) => ('Statuses ('+values.length+')')"
                                :selectOptions="slotProps.filterData.statuses"
                                :options="{multi: true}" />
                        </div>
                        <div class="d-inline-block">
                            <multi-select v-model="slotProps.filters['incident.IncidentTypeId']" :btnLabel="(values) => ('Incident Types ('+values.length+')')" :selectOptions="slotProps.filterData.incidentTypes" :options="{multi: true}"></multi-select>
                        </div>
                        <div class="d-inline-block">
                            <multi-select v-model="slotProps.filters['incident.InjuryTypeId']" :btnLabel="(values) => ('Injury Types ('+values.length+')')" :selectOptions="slotProps.filterData.injuryTypes" :options="{multi: true}"></multi-select>
                        </div>
                        <div class="d-inline-block">
                            <multi-select v-model="slotProps.filters['jobsite.DivisionId']" :btnLabel="(values) => ('Divisions ('+values.length+')')" :selectOptions="slotProps.filterData.divisions" :options="{multi: true}"></multi-select>
                        </div>
                        <div class="d-inline-block">
                            <date-range-selector buttonTitle="Incident Date" v-model="slotProps.filters['incident.IncidentDate']" />
                        </div>
                        <div class="d-inline-block" style="width: 250px;">
                            <jobsite-select :selectedValues="slotProps.filters['incident.JobsiteId']" :forFilters="true" v-on:vselected="((data) => { slotProps.filters['incident.JobsiteId'] = data || {};  })" />
                        </div>
                        <div class="d-inline-block" style="width: 250px;">
                            <employee-select
                                :forFilters="true"
                                :selectedValues="slotProps.filters['incident.EmployeeId']"
                                v-on:vselected="((data) => { slotProps.filters['incident.EmployeeId'] = data || {}; })"
                                placeholder="Employee(s) Involved" />
                        </div>

                        <div class="mt-3">
                            <div v-if="slotProps.showMoreFilters">
                                <div class="form-inline">
                                    <div class="form-group mr-2">
                                        <label class="mr-1">PTP Completed:</label>
                                        <b-form-select v-model="slotProps.filters['incident.IsPtpCompleted']" size="sm" :options="[{value: null, text: '-- Show All--'}, {value: 0, text: 'No'}, {value: 1, text: 'Yes'}]"></b-form-select>
                                    </div>
                                    <div class="form-group">
                                        <label class="mr-1">PTP Thorough:</label>
                                        <b-form-select v-model="slotProps.filters['incident.IsPtpThorough']" size="sm" :options="[{value: null, text: '-- Show All--'}, {value: 0, text: 'No'}, {value: 1, text: 'Yes'}]"></b-form-select>
                                    </div>
                                </div>
                                <div class="form-inline mt-3">
                                    <div class="form-group mr-2">
                                        <label class="mr-1">Has Days Away From Work:</label>
                                        <b-form-select v-model="slotProps.filters['incident.AwayFromWorkDays']" size="sm" :options="[{value: null, text: '-- Show All--'}, {value: 0, text: 'No'}, {value: 1, text: 'Yes'}]"></b-form-select>
                                    </div>
                                    <div class="form-group">
                                        <label class="mr-1">Has Days Transfer/Restriction:</label>
                                        <b-form-select v-model="slotProps.filters['incident.JobTransferOrRestrictionDays']" size="sm" :options="[{value: null, text: '-- Show All--'}, {value: 0, text: 'No'}, {value: 1, text: 'Yes'}]"></b-form-select>
                                    </div>
                                </div>
                                <div class="form-inline mt-3">
                                    <div class="form-group mr-2">
                                        <label class="mr-1">Is Equipment Incident:</label>
                                        <b-form-select v-model="slotProps.filters['incident.has_equipment_id']" size="sm" :options="[{value: null, text: '-- Show All--'}, {value: 0, text: 'No'}, {value: 1, text: 'Yes'}]"></b-form-select>
                                    </div>
                                    <div class="form-group mr-2">
                                        <label class="mr-1">Equipment Type:</label>
                                        <multi-select v-model="slotProps.filters['equipment.equipment_type_id']" :btnLabel="(values) => ('Equipment Types ('+values.length+')')" :selectOptions="slotProps.filterData.equipmentTypes" :options="{multi: true}"></multi-select>
                                    </div>
                                    <div class="form-group">
                                        <label class="mr-1">Equipment:</label>
                                        <equipment-select  :selectedValues="slotProps.filters['incident.equipment_id']" :forFilters="true" style="min-width: 200px;" v-on:vuselected="((data) => { slotProps.filters['incident.equipment_id'] = data || {};  })" />
                                    </div>
                                </div>
                                <div class="form-inline mt-3">
                                    <div class="form-group mr-2">
                                        <label class="mr-1">Root Causes:</label>
                                        <multi-select v-model="slotProps.filters['incident_hazards.hazard_id']" :btnLabel="(values) => ('Hazards ('+values.length+')')" :selectOptions="slotProps.filterData.hazards" :options="{multi: true}"></multi-select>
                                    </div>
                                    <div class="form-group mr-2">
                                        <multi-select v-model="slotProps.filters['incident_behaviors.behavior_id']" :btnLabel="(values) => ('Behaviors ('+values.length+')')" :selectOptions="slotProps.filterData.behaviors" :options="{multi: true}"></multi-select>
                                    </div>
                                    <div class="form-group">
                                        <multi-select v-model="slotProps.filters['incident_conditions.condition_id']" :btnLabel="(values) => ('Conditions ('+values.length+')')" :selectOptions="slotProps.filterData.conditions" :options="{multi: true}"></multi-select>
                                    </div>
                                </div>
                                <div class="form-inline mt-3">
                                    <div class="form-group mr-2">
                                        <label class="mr-1">OSHA Recordable:</label>
                                        <b-form-select v-model="slotProps.filters['incident.IsOshaRecordable']" size="sm" :options="[{value: null, text: '-- Show All--'}, {value: 0, text: 'No'}, {value: 1, text: 'Yes'}]"></b-form-select>
                                    </div>
                                    <div class="form-group">
                                        <label class="mr-1">DOT Recordable:</label>
                                        <b-form-select v-model="slotProps.filters['incident.IsDotRecordable']" size="sm" :options="[{value: null, text: '-- Show All--'}, {value: 0, text: 'No'}, {value: 1, text: 'Yes'}]"></b-form-select>
                                    </div>
                                </div>
                            </div>
                            <a href="javascript:void(0)" class="d-block mt-2" v-on:click="toggleMoreFilters()">
                                <template v-if="slotProps.showMoreFilters == false">
                                    <i class="fa fa-plus"></i> More Filters
                                </template>
                                <template v-else>
                                    <i class="fa fa-minus"></i> Hide Filters
                                </template>
                            </a>
                        </div>
                    </template>
                </table-filters-2>
            </div>

            <button type="button" class="btn btn-outline-success" v-on:click="exportIncidents()" :disabled="exportingTable">
                <span v-if="!exportingTable">
                    <i class="fa fa-file-excel-o"></i> {{ __('general.export') }}
                </span>
                <span v-else>
                    <i class="fa fa-spinner fa-spin"></i> {{ __('general.exporting') }}
                </span>
            </button>

            <div class="clearfix d-md-none d-block"></div>
        </div>

        <router-link slot="IncidentId" slot-scope="props" :to="`/incidents/view/${props.row.IncidentId}`" title="View Incident" class="btn btn-sm btn-light">
            View - {{ props.row.IncidentId }}
        </router-link>

        <template slot="EmpLastName" slot-scope="props">
            <router-link :to="`/employees/view/${props.row.EmployeeId}`" title="View Employee">
                {{ props.row.EmpFirstName }} {{ props.row.EmpLastName }} - {{ props.row.EmployeeNumber }}

            </router-link>
            <template v-if="props.row.additional_employees && props.row.additional_employees.length > 0">
                + {{ props.row.additional_employees.length }} More
            </template>
        </template>

        <template slot="user_id" slot-scope="props">
            {{ props.row.first_name }} {{ props.row.last_name }}
        </template>

        <template slot="IncidentDate" slot-scope="props">
            {{ props.row.IncidentDate | moment("MM/DD/YYYY") }}
        </template>

        <template slot="status_name" slot-scope="props">
            <label :class="`badge badge-${props.row.status_color}`">{{ props.row.status_name }}</label>
        </template>

        <template slot="JobsiteName" slot-scope="props">
            <router-link :to="`/jobsites/view/${props.row.JobsiteId}`" title="View Jobiste" v-if="props.row.JobsiteId">
                {{ props.row.JobsiteName }}
            </router-link>
            <span title="Non-Jobsite Location" v-else>
                {{ props.row.other_location }}
            </span>
        </template>

        <template slot="created_at" slot-scope="props">
            {{ props.row.created_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}
        </template>

        <template slot="child_row" slot-scope="props">
            <div class="mb-2">
                <label class="text-muted">Additional Employees:</label>
                <template v-if="!props.row.additional_employees || props.row.additional_employees.length == 0">
                    --
                </template>
                <template v-else>
                    <span v-for="(emp, key) in props.row.additional_employees">
                        <template v-if="key > 0">, </template>
                        <router-link :to="`/employees/view/${emp.EmployeeId}`">{{ emp.FirstName }} {{ emp.LastName }}</router-link>
                    </span>
                </template>

            </div>

            <div class="mb-2">
                <label class="text-muted">Days Away From Work:</label>&nbsp;
                <incident-days-away :incident="props.row" days_attr="AwayFromWorkDays" start_date_attr="date_first_away_from_work" end_date_attr="date_returned_away_from_work" />
            </div>

            <div class="mb-2">
                <label class="text-muted">Days on Job Transfer or Restriction:</label>&nbsp;
                <incident-days-away :incident="props.row" days_attr="JobTransferOrRestrictionDays" start_date_attr="date_first_transfer_or_restrict" end_date_attr="date_returned_transfer_or_restrict" />
            </div>

            <div class="mb-2">
                <label class="text-muted">Detailed Description</label>
                <div v-html="props.row.DetailedDescription"></div>
            </div>

        </template>
    </v-server-table>
</div>
</template>

<script>
    import filterExtractor from '@/helpers/TableFilterExtractor';
    import customVTColDropdown from '@/components/vue-tables-2/CustomColumnDropdown';

    export default {
        props: {
            assetType: {
                type: String,
                default: null
            },

            assetId: {
                type: Number,
                default: null
            },

            allowFilterSaving: {
                type: Boolean,
                default: false,
            },

            filterId: {
                type: Number,
                default: null,
            },

            dashboardFilters: {
                type: Object,
                default(){
                    return null;
                },
            },

            tableConfig: {
                type: Object,
                default(){
                    return null;
                },
            },
        },

        data() {
            return {
                exportingTable: false,
                savedFilter: null,
                showMoreFilters: false,
                userTimezone: this.$store.state.user.timezone,
                tableName: "incidentTable",
                columns: [
                    'IncidentId',
                    'EmpLastName',
                    'IncidentDate',
                    'status_name',
                    'IncidentTypeName',
                    'InjuryTypeName',
                    'DivisionName',
                    'JobsiteName',
                    'JobsiteNumber',
                    'user_name',
                    'created_at'
                ],
                headings: {
                    IncidentId: 'ID',
                    EmpLastName: 'Employee',
                    IncidentDate: 'Incident Date',
                    status_name: 'Status',
                    total_cost: 'Total',
                    IncidentTypeName: 'Type',
                    InjuryTypeName: 'Injury',
                    DivisionName: 'Division',
                    JobsiteName: 'Jobsite',
                    JobsiteNumber: 'Jobsite#',
                    user_name: 'Creator',
                    created_at: 'Created'
                },

                filterKey: 'incidentFilters',

                filterDefs: {
                    'incident.status_id': [],
                    'incident.IncidentTypeId': [],
                    'incident.InjuryTypeId': [],
                    'jobsite.DivisionId': [],
                    'incident.IncidentDate' : '',
                    'incident.JobsiteId' : {},
                    'incident.IsPtpCompleted': null,
                    'incident.IsPtpThorough': null,
                    'incident.AwayFromWorkDays': null,
                    'incident.JobTransferOrRestrictionDays': null,
                    'equipment.equipment_type_id': [],
                    'incident.equipment_id' : {},
                    'incident_hazards.hazard_id': [],
                    'incident_behaviors.behavior_id': [],
                    'incident_conditions.condition_id': [],
                    'incident.EmployeeId': {},
                    'incident.IsOshaRecordable': null,
                    'incident.IsDotRecordable': null,
                    'incident.has_equipment_id': null,
                },
            }
        },

        watch: {
            appliedFilter(newVal, oldVal){
                //Call the helper
                this.checkForAppliedFilter();
            },
        },

        computed: {
            options(){
                return {
                    headings: this.headings,
                    texts: {
                        //filterPlaceholder: this.$root.__('general.search') + " " + this.$root.__('incidents.label_plural'),
                        //columns: this.$root.__('general.columns'),

                        // count: "Showing {from} to {to} of {count} records|{count} records|One record",
                        // first: 'First',
                        // last: 'Last',
                        // filter: "Filter:",
                        // filterPlaceholder: "Search query",
                        // limit: "Records:",
                        // page: "Page:",
                        // noResults: "No matching records",
                        // filterBy: "Filter by {column}",
                        // loading: 'Loading...',
                        // defaultOption: 'Select {column}',
                        //columns: 'Columns',
                    },
                    saveState: (!this.dashboardFilters ? true : false),
                    filterable: (!this.dashboardFilters ? true : false),
                    columnsDropdown: customVTColDropdown,
                    visibleColumns: this.$root.getVisibleColumnsFromState(this.tableName),
                    sendInitialRequest: (this.filterId ? false : true),
                    orderBy: {
                        ascending: false,
                        column: 'incident.IncidentDate',
                    },
                    responseAdapter: (response) => {
                        //Emit the count
                        this.$emit('incidentListCount', response.data.count);

                        //Send it
                        return response.data;
                    },
                    requestAdapter: (data) => {
                        //Set the filters
                        data.filters = (this.dashboardFilters ? filterExtractor.extractFilters(this.dashboardFilters) : filterExtractor.extractFilters(this.filters));

                        //INclude the asset
                        data.assetType = this.assetType;
                        data.assetId = this.assetId;

                        //Send it
                        return data;
                    },
                    uniqueKey: 'IncidentId',
                };
            },

            filters(){
                //Check State
                if(this.$store.state.tableFilters.filters[this.filterKey])
                {
                    //Send it
                    return this.$store.state.tableFilters.filters[this.filterKey];
                }

                //Return Definition
                return JSON.parse(JSON.stringify(this.filterDefs));
            },

            appliedFilter(){
                //Send it
                return this.$store.state.appliedFilters[this.filterKey] ? this.$store.state.appliedFilters[this.filterKey] : null;
            },
        },

        methods: {

            toggleMoreFilters(){
                this.showMoreFilters = !this.showMoreFilters;
            },

            exportIncidents(){
                //Loading indicator
                this.exportingTable = true;

                //Build the payload
                var payload = {
                    filters: (this.dashboardFilters ? filterExtractor.extractFilters(this.dashboardFilters) : filterExtractor.extractFilters(this.filters)),
                    query: (this.$refs.incidentTable.getRequestParams()).query,
                    orderBy: this.$refs.incidentTable.options.orderBy.column,
                    ascending: this.$refs.incidentTable.options.orderBy.ascending,
                    table: 'incident-table',
                    columns: this.$refs.incidentTable.columns,
                    visible_columns: this.$root.getVisibleColumnsFromState(this.tableName),
                    assetType: this.assetType,
                    assetId: this.assetId,
                };

                //Send it
                this.$http.post('/incident/export', payload)
                    .then(response => {
                        //Open the new window
                        window.open(response.data);
                    })
                    .catch(err => {})
                    .then(response => {
                        //reset
                        this.exportingTable = false;
                    });
            },

            refreshTableData(filters) {
                //Set the data
                this.$refs.incidentTable.setPage(1);
                //this.$refs.incidentTable.getData();
            },

            filtersCleared(){
                //Reset
                this.refreshTableData();

                //Reset the Columns
                this.$refs.incTableFilters.resetColVis(this.$refs.incidentTable);
            },

            setUserFilterData(){
                //Call the Helper
                this.$refs.incSavedFilters.setFilterParams(this.$refs.incidentTable);
            },

            checkForAppliedFilter(){
                //Check if
                if(!this.allowFilterSaving || !this.appliedFilter)
                {
                    return;
                }

                //Call the helper
                this.$refs.incTableFilters.setColVis(this.$refs.incidentTable);
            },
        },

        mounted(){
            //Check for Staring Filters
            if(!this.dashboardFilters)
            {
                //Set it
                //this.$refs.incTableFilters.setFilters(this.dashboardFilters);

                //Check for a saved filter
                this.checkForAppliedFilter();

                //Check for Filter ID
                if(this.filterId)
                {
                    this.$refs.incSavedFilters.setSavedFilter(this.filterId);
                }
            }

            //Check for Table Config
            if(this.tableConfig)
            {
                //Set it
                this.$refs.incTableFilters.setColVisFromSavedFilter(this.$refs.incidentTable, this.tableConfig);
            }
        },

        updated(){

        },
    }
</script>
